// Purchase Order related
export const QUERY_PARAM_PURCHASE_ORDER = "po";
export const QUERY_PARAM_POFE = "pofe";
export const QUERY_PARAM_POFE_DETAILS_MODAL = "pofe-details-modal";

// Toast & Success Messages
export const COPIED_TO_CLIPBOARD = "copied-to-clipboard";
export const CHANGES_SAVED = "changes-saved";
export const ADDRESS_UPDATED = "address-updated";
export const FINALIZED = "finalized";
export const PASSWORD_CHANGE_SUCCESS = "password-change-success";
export const PASSWORD_CREATE_SUCCESS = "password-create-success";
export const BULK_EDIT_SELECT_MIN_RECORDS = "bulk-edit-select-min-records";
export const OFFER_CREATED = "offer-created";
export const OFFER_UPDATED = "offer-updated";
export const BULK_UPDATE_SUCCESS = "bulk-update-success";

// Error Messages
export const ERROR_HAS_HAPPENED = "error-has-happened";
export const ERROR_MESSAGE = "error-message";
export const ERROR_OCCURRED_WHILE_UPDATING = "error-occurred-while-updating";
export const ERROR_OCCURRED_WHILE_UPLOADING_FILES = "error-occurred-while-uploading-files";
export const ERROR_DOWNLOADING_INVOICE = "error-downloading-invoice";
export const ERROR_NO_CONTACT_FOUND_FOR_SUPPLIER = "error-no-contact-found-for-supplier";

// Account
export const IMPERSONATING_ACCOUNT = "impersonating_account";

// Modals
export const IS_WEEK_PICKER_MODAL_OPEN = "week-picker-open";
export const IS_DATE_PICKER_MODAL_OPEN = "date-picker-open";
export const HAS_SEEN_MODAL = "hasSeenModal";

// Cart & Items
export const ITEM_QUANTITY_HAS_CHANGED = "item-quantity-has-changed";
export const ENTERED_QUANTITY_IS_OVER_AVAILABLE_QUANTITY = "entered-quantity-is-over-available-quantity";
export const ITEM_DELIVERY_DATE_HAS_CHANGED = "item-delivery-date-has-changed";
export const ITEM_HAS_BEEN_REMOVED = "item-has-been-removed";
export const ITEM_HAS_BEEN_ADDED_TO_CART = "item-has-been-added-to-cart";
export const ITEM_HAS_BEEN_MERGED = "item-has-been-merged";
export const ITEM_CAN_NOT_MERGE = "item-can-not-merge";
